import { Component, Input, OnChanges, input } from '@angular/core';
import { valueAccessorProvider } from '@scripts/utils/provider-builders';
import { AbstractValueAccessor } from '../../utils/AbstractValueAccessor';
import { SimpleChanges } from '../../utils/types';

@Component({
  selector: 'woo-dropdown',
  templateUrl: './woo-dropdown.component.html',
  styleUrls: ['./woo-dropdown.component.scss'],
  providers: [valueAccessorProvider(WooDropdown)],
  standalone: false,
})
export class WooDropdown<T, U> extends AbstractValueAccessor<U> implements OnChanges {
  items = input<T[]>([]);
  inputId = input<string>('');
  labelText = input<string>('');
  labelColor = input<string>('#000000');
  loading = input<boolean>(false);
  /**
   * The property of an item to be displayed in the list as the label
   */
  bindLabel = input<string>('name');

  /**
   * The property of an item to be used as value and set to model
   * Null means the entire item
   */
  bindValue = input<string>(null);

  /**
   * Function to transform the label of items, e.g. a translation
   */
  @Input() labelTransform: (args: any) => string;
  clearable = input<boolean>(false);
  multiple = input<boolean>(false);
  disabled = input<boolean>(false);
  notFoundText = input<string>('Inga matchningar');
  placeholder = input<string>('');

  searchAttributes = input<string[]>([]);

  searchFn;

  ngOnChanges(changes: SimpleChanges<WooDropdown<T, U>>): void {
    if (changes.searchAttributes && this.searchAttributes) {
      this.searchFn = this.searchForAttributes(this.searchAttributes());
    }
  }

  searchForAttributes(attributes: string[]) {
    return function (searchTerm: string, item: any): boolean {
      let exists = false;
      attributes.forEach((attr) => {
        if (item[attr] && item[attr].toLowerCase().includes(searchTerm.toLowerCase())) {
          exists = true;
        }
      });
      return exists;
    };
  }
}
